<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-content>
        <v-snackbar
                v-model="snackbars['error'].enabled"
                :color="'warning'"
                :timeout="2000"
                :top="true">
            {{snackbars['error'].message}}
        </v-snackbar>
        <v-container fluid fill-height>
            <v-layout justify-center class="pt-5">
                <v-flex xs12 sm12 md4>
                    <div class="mb-3">
                        <img src="@/assets/caliber2019_transparent.png"/>
                    </div>
                    <v-card>
                        <v-card-title>Portal Sign-In</v-card-title>
                        <v-subheader v-if="message != null">
                            {{message}}
                        </v-subheader>
                        <v-form @submit="login" onSubmit="return false" ref="loginForm">
                            <v-card-text>
                                <v-text-field v-model="username" prepend-icon="mdi-account" name="username" label="E-Mail" type="text" autofocus required></v-text-field>
                                <v-text-field v-model="password" prepend-icon="mdi-lock" name="password" label="Password" id="password" type="password" required></v-text-field>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn type="button" @click="gotoReset()">Forgot Password?</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn text color="green" type="submit">Login</v-btn>
                            </v-card-actions>
                            <v-card-actions stye="text-align:center">
                                <v-btn text type="button" color="blue" @click="tip()">Submit Anonymous Tip</v-btn>
                            </v-card-actions>

                        </v-form>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>

<script>
    import api from '@/api';
    import axios from 'axios';
    export default {
        data() {
            return {
                message : null,
                username : null,
                password : null,
                snackbars: {
                    'error': {
                        enabled:false,
                        message:'Invalid Username or Password'
                    }
                }
            }
        },
        mounted() {
            if (document.getElementById('loginError') != null) {
                this.message = 'Invalid Username and Password';
            } else if (document.getElementById('logout') != null) {
                this.message = 'You Have Been Logged Out';
            }
        },
        methods : {
            login() {
                api.auth.get(this.username,this.password).then((data) => {
                    if (data.success && data.token) {
                        api.setAuth(data.token);
                        if (data.firstLogin) {
                            this.$router.replace("/ft");
                        } else {
                            this.$router.replace("/");
                        }

                    }
                },(error) => {
                    this.snackbars['error'].message = error.response.data.message;
                    this.snackbars['error'].enabled = true;
                });
            },
            gotoReset() {
                window.location.href="reset_password_request.html";
            },
            tip() {
                window.location.href="submit_tip.html";
            }
        }
    }
</script>